/**
 * This is the entry point for specific javascript of theme
 */


console.log('Alps Theme');
const selectHotspot = (e) => {
const clickedHotspot = e.target.parentElement;
const container = clickedHotspot.parentElement;

// only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
const hotspots = container.querySelectorAll(".lg-hotspot"); 
hotspots.forEach(hotspot => {
    if (hotspot === clickedHotspot) {
    hotspot.classList.toggle("lg-hotspot--selected");
    } else {
    hotspot.classList.remove("lg-hotspot--selected");
    }
});
}

(() => {
const buttons = document.querySelectorAll(".lg-hotspot__button");
buttons.forEach(button => {
    button.addEventListener("click", selectHotspot);
});
})();
  
var swiper = new Swiper(".swiper-materie", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
const languageSwitchers = document.querySelectorAll('.custom-language-selector');

languageSwitchers.forEach((languageSwitcher) => {
    languageSwitcher.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target;
        const clickedLanguage = target.dataset.lang;
        console.log(clickedLanguage);

        const languageForm = target.closest('form');
        const select = languageForm.querySelector('select');
        select.value = clickedLanguage;
        languageForm.submit();
    });
});




// WEBPACK FOOTER //
// ./js/theme.js